module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n          Catalog\n          →\n          "), (_vm.$route.name.indexOf('product') !== -1) ? _c('span', [(_vm.$route.name !== 'products') ? _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'products'
      }
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('span', [_vm._v("→")]), _vm._v(" "), (_vm.$route.name === 'product') ? _c('span', [_vm._v(_vm._s(_vm.getProduct(_vm.$route.params.id).name))]) : _c('span', [_vm._v("New Product")])], 1) : _c('span', [_vm._v("Products")])]) : _vm._e(), _vm._v(" "), (_vm.$route.name.indexOf('bundle') !== -1) ? _c('span', [(_vm.$route.name !== 'bundles') ? _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'bundles'
      }
    }
  }, [_vm._v("Bundles")]), _vm._v(" "), _c('span', [_vm._v("→")]), _vm._v(" "), (_vm.$route.name === 'bundle') ? _c('span', [_vm._v(_vm._s(_vm.getBundle(_vm.$route.params.id).name))]) : _c('span', [_vm._v("New Bundle")])], 1) : _c('span', [_vm._v("Bundles")])]) : _vm._e(), _vm._v(" "), (_vm.$route.name.indexOf('categor') !== -1) ? _c('span', [(_vm.$route.name !== 'categories') ? _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'categories'
      }
    }
  }, [_vm._v("Categories")]), _vm._v(" "), _c('span', [_vm._v("→")]), _vm._v(" "), (_vm.$route.name === 'category') ? _c('span', [_vm._v(_vm._s(_vm.getCategory(_vm.$route.params.id).name))]) : _c('span', [_vm._v("New Category")])], 1) : _c('span', [_vm._v("Categories")])]) : _vm._e(), _vm._v(" "), (_vm.$route.name.indexOf('discount') !== -1) ? _c('span', [(_vm.$route.name !== 'discounts') ? _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'discounts'
      }
    }
  }, [_vm._v("Discounts")]), _vm._v(" "), _c('span', [_vm._v("→")]), _vm._v(" "), (_vm.$route.name === 'discount') ? _c('span', [_vm._v(_vm._s(_vm.getDiscount(_vm.$route.params.id).name))]) : _c('span', [_vm._v("New Discount")])], 1) : _c('span', [_vm._v("Discounts")])]) : _vm._e(), _vm._v(" "), (_vm.$route.name.indexOf('item') !== -1) ? _c('span', [(_vm.$route.name !== 'items') ? _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'items'
      }
    }
  }, [_vm._v("Items")]), _vm._v(" "), _c('span', [_vm._v("→")]), _vm._v(" "), (_vm.$route.name === 'item') ? _c('span', [_vm._v(_vm._s(_vm.getItem(_vm.$route.params.id).name))]) : _c('span', [_vm._v("New Item")])], 1) : _c('span', [_vm._v("Items")])]) : _vm._e(), _vm._v(" "), (_vm.$route.name.indexOf('tag') !== -1) ? _c('span', [(_vm.$route.name !== 'tags') ? _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'tags'
      }
    }
  }, [_vm._v("Tags")]), _vm._v(" "), _c('span', [_vm._v("→")]), _vm._v(" "), (_vm.$route.name === 'tag') ? _c('span', [_vm._v(_vm._s(_vm.getTag(_vm.$route.params.id).name))]) : _c('span', [_vm._v("New Tag")])], 1) : _c('span', [_vm._v("Tags")])]) : _vm._e(), _vm._v(" "), (_vm.$route.name.indexOf('month') !== -1) ? _c('span', [_vm._v("Months")]) : _vm._e(), _vm._v(" "), (_vm.$route.name.indexOf('referral_source') !== -1) ? _c('span', [_vm._v("Referral Sources")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'products'
      }
    }
  }, [_c('a', [_vm._v("Products")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'bundles'
      }
    }
  }, [_c('a', [_vm._v("Bundles")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'categories'
      }
    }
  }, [_c('a', [_vm._v("Categories")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'items'
      }
    }
  }, [_c('a', [_vm._v("Items")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'tags'
      }
    }
  }, [_c('a', [_vm._v("Tags")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'months'
      }
    }
  }, [_c('a', [_vm._v("Months")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'discounts'
      }
    }
  }, [_c('a', [_vm._v("Discounts")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'referral_sources'
      }
    }
  }, [_c('a', [_vm._v("Referral Sources")])])], 1)]), _vm._v(" "), _c('div', [_c('transition', {
    attrs: {
      "mode": "out-in",
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40e80346"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/Catalog.vue
// module id = 527
// module chunks = 0